import React from "react";
import { FormattedMessage } from "react-intl";

const CardQuestion = ({ title, content, contentValues }) => {
  return (
    <div className="roi--card-question-container">
      <div style={{ marginBottom: "8px" }}>
        <span className="roi--card-question-title">
          {<FormattedMessage id={title} />}
        </span>
      </div>
      <div className="roi--card-question-content">
        {<FormattedMessage id={content} values={contentValues} />}
      </div>
    </div>
  );
};

export default CardQuestion;
